import { ConfigEvent, isValidSocketEvent } from "./events";

declare const process: {
  env: {
    ELEVENLABS_CONVAI_SERVER_ORIGIN?: string;
    ELEVENLABS_CONVAI_SERVER_PATHNAME?: string;
  };
};

export type SessionConfig =
  | { signedUrl: string; agentId?: undefined }
  | { agentId: string; signedUrl?: undefined };

const WSS_API_ORIGIN = "wss://api.elevenlabs.io";
const WSS_API_PATHNAME = "/v1/convai/conversation?agent_id=";

export class Connection {
  public static async create(config: SessionConfig): Promise<Connection> {
    let socket: WebSocket | null = null;

    try {
      const origin =
        (typeof process !== "undefined"
          ? process.env.ELEVENLABS_CONVAI_SERVER_ORIGIN
          : null) ?? WSS_API_ORIGIN;

      const pathname =
        (typeof process !== "undefined"
          ? process.env.ELEVENLABS_CONVAI_SERVER_PATHNAME
          : null) ?? WSS_API_PATHNAME;

      const url = config.signedUrl
        ? config.signedUrl
        : origin + pathname + config.agentId;

      socket = new WebSocket(url);
      const conversationConfig = await new Promise<
        ConfigEvent["conversation_initiation_metadata_event"]
      >((resolve, reject) => {
        socket!.addEventListener("error", reject);
        socket!.addEventListener("close", reject);
        socket!.addEventListener(
          "message",
          (event: MessageEvent) => {
            const message = JSON.parse(event.data);

            if (!isValidSocketEvent(message)) {
              return;
            }

            if (message.type === "conversation_initiation_metadata") {
              resolve(message.conversation_initiation_metadata_event);
            } else {
              console.warn(
                "First received message is not conversation metadata."
              );
            }
          },
          { once: true }
        );
      });

      const conversationId = conversationConfig.conversation_id;
      const sampleRate = parseInt(
        conversationConfig.agent_output_audio_format.replace("pcm_", "")
      );

      return new Connection(socket, conversationId, sampleRate);
    } catch (error) {
      socket?.close();
      throw error;
    }
  }

  private constructor(
    public readonly socket: WebSocket,
    public readonly conversationId: string,
    public readonly sampleRate: number
  ) {}

  public close() {
    this.socket.close();
  }
}
